var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imd-sm-progrss-wrap"},[(_vm.value)?_c('spinner',{staticStyle:{"position":"absolute","margin":"30px 50%"},attrs:{"size":"huge"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }